<template>
  <all-tours></all-tours>
</template>

<script>
import AllTours from '../components/AllTours.vue';
// import AllTours from "../components/AllTours.vue";
export default {
  components: { AllTours },
  name: 'HomeView',

};
</script>

<style>

</style>
